<template>
  <div class="alchemy-room">
    <div class="room-header">
      <div class="header-info">
        <div class="room-icon" style="background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%)">
          <Icon type="ios-flame" size="24" color="#fff" />
        </div>
        <div>
          <h3 class="room-title">
            炼丹房
            <Poptip trigger="click" placement="bottom-start" width="550" word-wrap>
              <Icon type="ios-information-circle-outline" size="18" class="desc-icon" />
              <div slot="content" class="design-desc-content"><div class="desc-title">炼丹房设计说明</div><p>① 1级炼丹房成功率40% 2级45% 3级50% 以此类推 <span class="highlight">（总成功率 = 炼丹房基础率 + 辅材率 + 炼丹时辰加成 + 熟练度加成）+福源幸运加成</span></p><p>② 普通丹药一炉最多生成12个独立结果；永久丹和突破丹一炉固定1颗</p><p>③ 1级炼丹房炼制一炉丹药需要12个时辰 2级6 3级4 4级2.4 5级...</p><p>④ 丹药分类：临时提升、永久提升、特殊用途和突破丹；具体效果与时效以丹药配置为准</p><p>⑤ 丹纹系统和效果 炼制的丹药有几率出现丹纹，最高为10纹丹药；固定效果丹药不受丹纹影响</p><p>⑥ 炼丹等级和丹纹关系 每级略微减少低级丹纹出现概率，略微增加高级丹纹出现概率</p><p>⑦ 已映射的炼丹材料可由本体背包与灵田库存共同提供</p><p>⑧ 丹方获取途径：商店兑换、副本掉落或灵田融合解锁</p></div>
            </Poptip>
          </h3>
          <p class="room-desc">炼制丹药提升修为</p>
        </div>
      </div>
      <div class="header-stats">
        <div class="stat-item">
          <span class="stat-label">已分配</span>
          <span class="stat-value">{{ points }}时辰</span>
        </div>
        <div class="stat-item">
          <span class="stat-label">基础成功率</span>
          <span class="stat-value">{{ baseSuccessRate }}%</span>
        </div>
      </div>
      <Button type="info" size="small" @click="$emit('upgrade')">
        <Icon type="ios-arrow-up" /> Lv.{{ level }}
      </Button>
    </div>

    <div class="room-content">
      <div class="alchemy-tabs">
        <div
          :class="['alchemy-tab', { active: activeTab === 'recipes' }]"
          @click="activeTab = 'recipes'"
        >
          <Icon type="ios-flask" />
          <span>丹方名录</span>
        </div>
        <div
          :class="['alchemy-tab', { active: activeTab === 'delegating' }]"
          @click="activeTab = 'delegating'"
        >
          <Icon type="ios-time" />
          <span>委托记录</span>
          <span class="tab-count" v-if="delegatingList.length > 0">{{ delegatingList.length }}</span>
        </div>
      </div>

      <div v-show="activeTab === 'recipes'" class="alchemy-layout">
        <!-- 左侧丹方列表 -->
        <div class="recipe-list-panel">
          <div class="list-header">
            <div class="list-title">丹方名录</div>
            <div class="list-actions">
              <Input
                v-model="recipeSearch"
                placeholder="搜索丹方..."
                size="small"
                clearable
                style="width: 150px"
              >
                <Icon type="ios-search" slot="prefix" />
              </Input>
              <Select v-model="recipeFilter" size="small" style="width: 90px">
                <Option value="all">全部</Option>
                <Option value="can">可炼制</Option>
              </Select>
            </div>
          </div>

          <div class="recipe-items">
            <div
              v-for="(recipe, index) in filteredRecipes"
              :key="recipe.formulaId || index"
              :class="['recipe-item', {
                active: selectedRecipe && selectedRecipe.formulaId === recipe.formulaId,
                'can-make': recipe.isMeet
              }]"
              @click="selectRecipe(recipe)"
            >
              <div class="recipe-header">
                <div class="recipe-name">{{ recipe.itemName }}</div>
                <div class="recipe-status">
                  <span v-if="recipe.isMeet" class="status-tag success">可炼制</span>
                  <span v-else class="status-tag disabled">材料不足</span>
                </div>
              </div>
              <div class="recipe-info">
                <span class="info-item">
                  <Icon type="ios-pulse" />
                  {{ getRecipeRate(recipe) }}%
                </span>
                <span class="info-item">
                  <Icon type="ios-time" />
                  {{ recipe.costTime }}s
                </span>
                <span class="info-item">
                  <Icon type="ios-school" />
                  Lv.{{ recipe.proficiencyLevel || 0 }}
                </span>
              </div>
            </div>

            <div class="empty-state" v-if="filteredRecipes.length === 0">
              <Icon type="ios-flask-outline" size="32" />
              <p>暂无丹方</p>
            </div>
          </div>
        </div>

        <!-- 右侧详情 -->
        <div class="recipe-detail-panel">
          <template v-if="selectedRecipe">
            <div class="detail-header">
              <h3 class="detail-title">{{ selectedRecipe.itemName }}</h3>
              <div class="detail-desc" v-if="selectedRecipe.desci">
                {{ selectedRecipe.desci }}
              </div>
            </div>

            <div class="materials-section">
              <div class="section-title">
                <Icon type="ios-flask" />
                <span>所需材料</span>
                <span class="material-status" :class="{ ready: selectedRecipe.isMeet }">
                  <Icon :type="selectedRecipe.isMeet ? 'ios-checkmark-circle' : 'ios-close-circle'" />
                  {{ selectedRecipe.isMeet ? '材料齐全' : '材料不足' }}
                </span>
              </div>

              <div class="materials-grid">
                <div
                  v-for="(mat, index) in selectedRecipe.matList"
                  :key="index"
                  :class="['material-item', {
                    sufficient: isMaterialEnough(mat, index),
                    insufficient: !isMaterialEnough(mat, index),
                    'main-material': mat.type === 1
                  }]"
                >
                  <div class="material-header">
                    <span class="material-type">
                      {{ mat.type === 1 ? '主材' : '辅材' }}
                    </span>
                    <span class="material-name">{{ mat.itemName }}<small v-if="mat.crossInventory" class="material-source">本体+灵田 · {{ mat.sourcePolicy === 'BAG_FIRST' ? '优先本体' : (mat.sourcePolicy === 'FARM_FIRST' ? '优先灵田' : '合并取用') }}</small></span>
                  </div>
                  <div class="material-quantity">
                    <span class="current">{{ mat.haveNum }}</span>
                    <span class="separator">/</span>
                    <span class="required">{{ getRequiredTotal(mat, index) }}</span>
                  </div>
                  <div class="material-input" v-if="mat.type !== 1 && mat.haveNum > 0">
                    <InputNumber
                      v-model="auxiliaryNums[index]"
                      :min="0"
                      :max="mat.haveNum"
                      :step="1"
                      size="small"
                      @on-change="(val) => onAuxiliaryChange(mat.itemId, val, index)"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="alchemy-info">
              <div class="info-grid">
                <div class="info-block">
                  <div class="block-label">成功率</div>
                  <div class="block-value">
                    <div class="rate-number" :class="getRateClass(selectedRecipe.totalSuccessRate)">
                      {{ (selectedRecipe.totalSuccessRate * 100).toFixed(1) }}%
                    </div>
                    <div class="rate-detail" v-if="showRateDetail">
                      <span>基础 {{ (selectedRecipe.basicRate * 100).toFixed(1) }}%</span>
                      <span v-if="selectedRecipe.slotBonus > 0"> + 时辰 {{ (selectedRecipe.slotBonus * 100).toFixed(1) }}%</span>
                      <span v-if="selectedRecipe.caiRate > 0"> + 辅材 {{ (selectedRecipe.caiRate * 100).toFixed(1) }}%</span>
                      <span v-if="selectedRecipe.proficiencyBonus > 0"> + 熟练 {{ (selectedRecipe.proficiencyBonus * 100).toFixed(1) }}%</span>
                    </div>
                  </div>
                </div>

                <div class="info-block">
                  <div class="block-label">熟练度</div>
                  <div class="block-value">
                    <div class="proficiency-level">Lv.{{ selectedRecipe.proficiencyLevel || 0 }}</div>
                    <Progress
                      :percent="proficiencyPercent"
                      :stroke-width="6"
                      hide-info
                    />
                    <div class="proficiency-text">
                      {{ selectedRecipe.currentProficiency || 0 }}/{{ selectedRecipe.maxProficiency || 1 }}
                    </div>
                  </div>
                </div>

                <div class="info-block">
                  <div class="block-label">耗时/消耗</div>
                  <div class="block-value">
                    <div class="cost-item">
                      <Icon type="ios-clock-outline" />
                      <span>{{ selectedRecipe.costTime }}s</span>
                    </div>
                    <div class="cost-item">
                      <Icon type="ios-flash" />
                      <span>{{ selectedRecipe.costCoin || 0 }}灵石</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="alchemy-action">
              <span class="batch-info">一炉可炼 {{ selectedRecipe.batchMax || 12 }} 颗</span>
              <Button
                type="primary"
                :disabled="!canRefine"
                :loading="refining"
                @click="startRefining"
                class="refine-btn"
              >
                <Icon type="ios-flame" size="16" />
                {{ refining ? '炼丹中...' : '开始炼丹' }}
              </Button>
            </div>
          </template>

          <div class="no-selection" v-else>
            <Icon type="ios-flask-outline" size="64" />
            <h3>选择丹方开始炼丹</h3>
            <p>从左侧选择一个丹方查看详细信息</p>
          </div>
        </div>
      </div>

      <!-- 委托记录 -->
      <div v-show="activeTab === 'delegating'" class="delegating-section">
        <div class="section-header">
          <h4>委托记录</h4>
          <Button type="text" size="small" @click="loadDelegatingList">
            <Icon type="ios-refresh" /> 刷新
          </Button>
        </div>
        <div class="delegating-list">
          <div
            v-for="(item, index) in delegatingList"
            :key="item.id || index"
            :class="['delegating-item', { 'can-receive': isAlchemyReceivable(item) }]"
          >
            <div class="delegating-info">
              <div class="delegating-name">{{ item.name }}</div>
              <div class="delegating-status">
                <span v-if="isAlchemyReceivable(item)" class="status-tag waiting">待领取</span>
                <span v-else-if="isAlchemyProcessing(item)" class="status-tag processing">炼制中</span>
                <span v-else class="status-tag completed">已领取</span>
              </div>
            </div>
            <div class="delegating-detail">
              <span>成功率: {{ (item.rate * 100).toFixed(1) }}%</span>
              <span v-if="isAlchemyProcessing(item)">剩余: {{ getCountdown(item.linTime) }}</span>
            </div>
            <div class="delegating-actions">
              <Button
                v-if="isAlchemyReceivable(item)"
                type="success"
                size="small"
                :loading="receivingIndex === index"
                @click="receiveAlchemy(item, index)"
              >
                领取丹药
              </Button>
            </div>
          </div>

          <div class="empty-state" v-if="delegatingList.length === 0">
            <p>暂无委托炼丹任务</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlchemyRoom',
  props: {
    level: { type: Number, default: 1 },
    points: { type: Number, default: 0 },
    baseSuccessRate: { type: Number, default: 40 }
  },
  data() {
    return {
      activeTab: 'recipes',
      recipeList: [],
      recipeSearch: '',
      recipeFilter: 'all',
      selectedRecipe: null,
      auxiliaryNums: [],
      formulaMatZiList: [],
      refining: false,
      delegatingList: [],
      receivingIndex: null
    }
  },
  computed: {
    filteredRecipes() {
      let list = this.recipeList
      if (this.recipeSearch) {
        const keyword = this.recipeSearch.toLowerCase()
        list = list.filter(r =>
          (r.itemName || '').toLowerCase().includes(keyword) ||
          (r.effectDesc || '').toLowerCase().includes(keyword)
        )
      }
      if (this.recipeFilter === 'can') {
        list = list.filter(r => r.isMeet)
      }
      return [...list].sort((a, b) => {
        if (a.isMeet !== b.isMeet) return b.isMeet - a.isMeet
        return (b.proficiencyLevel || 0) - (a.proficiencyLevel || 0)
      })
    },
    proficiencyPercent() {
      if (!this.selectedRecipe) return 0
      return (this.selectedRecipe.currentProficiency / this.selectedRecipe.maxProficiency * 100) || 0
    },
    showRateDetail() {
      return this.selectedRecipe && (
        this.selectedRecipe.slotBonus > 0 ||
        this.selectedRecipe.caiRate > 0 ||
        this.selectedRecipe.proficiencyBonus > 0
      )
    },
    canRefine() {
      return this.selectedRecipe && this.selectedRecipe.isMeet && !this.refining
    },
    cannotRefineReason() {
      if (!this.selectedRecipe) return '请选择丹方'
      if (!this.selectedRecipe.isMeet) return '材料不足'
      return ''
    }
  },
  mounted() {
    this.loadRecipeList()
    this.loadDelegatingList()
  },
  methods: {
    async loadRecipeList() {
      try {
        const res = await this.$http.post(
          `/gameCharaEquip/queryLearnedFormulaList?charaId=${this.getCookie('charaId')}&formulaType=2`
        )
        if (res.data.status === 200) {
          this.recipeList = (res.data.data || []).map(this.normalizeRecipe)
        }
      } catch (err) {
        this.$Message.warning('加载丹方列表失败')
      }
    },
    normalizeRecipe(raw) {
      const recipe = { ...(raw || {}) }
      recipe.formulaId = recipe.formulaId || recipe.id || ''
      recipe.itemName = recipe.itemName || recipe.name || '未命名丹方'
      recipe.desci = recipe.desci || recipe.effectDesc || ''
      recipe.costTime = Number(recipe.costTime || 0)
      recipe.costCoin = Number(recipe.costCoin || 0)
      recipe.currentProficiency = Number(recipe.currentProficiency || 0)
      recipe.maxProficiency = Number(recipe.maxProficiency || 1)
      recipe.proficiencyLevel = Number(recipe.proficiencyLevel || 0)
      recipe.proficiencyBonus = Number(recipe.proficiencyBonus || 0)
      recipe.slotBonus = Number(recipe.slotBonus || 0)
      recipe.caiRate = Number(recipe.caiRate || 0)
      recipe.basicRate = Number(recipe.basicRate || recipe.baseRate || 0)
      recipe.batchMax = Number(recipe.batchMax || 12)
      recipe.matList = (recipe.matList || []).map(m => ({
        ...m,
        type: Number(m.type),
        num: Number(m.num || 0),
        haveNum: Number(m.haveNum || 0)
      }))
      recipe.totalSuccessRate = Math.min(1, recipe.basicRate + recipe.slotBonus + recipe.caiRate + recipe.proficiencyBonus)
      return recipe
    },
    getRecipeRate(recipe) {
      const rate = recipe.totalSuccessRate || (recipe.basicRate + recipe.slotBonus + recipe.caiRate + recipe.proficiencyBonus)
      return (Math.min(1, rate) * 100).toFixed(0)
    },
    async selectRecipe(recipe) {
      this.selectedRecipe = recipe
      try {
        const res = await this.$http.post(
          `/gameCharaEquip/queryForgingOrPills?charaId=${this.getCookie('charaId')}&packItemIds=${recipe.formulaId}&formulaType=2`
        )
        if (res.data.status === 200) {
          const data = res.data.data
          this.selectedRecipe = this.normalizeRecipe({
            ...recipe,
            ...data,
            formulaId: recipe.formulaId
          })
          this.initAuxiliaryMaterials()
        }
      } catch (err) {
        this.$Message.warning('获取丹方详情失败')
      }
    },
    initAuxiliaryMaterials() {
      this.auxiliaryNums = []
      this.formulaMatZiList = []
      if (!this.selectedRecipe || !this.selectedRecipe.matList) return

      this.selectedRecipe.matList.forEach((mat, idx) => {
        if (mat.type === 1) {
          this.auxiliaryNums[idx] = mat.num
        } else {
          const defaultNum = Math.min(mat.haveNum, mat.num)
          this.auxiliaryNums[idx] = defaultNum
          if (defaultNum > 0) {
            this.formulaMatZiList.push({
              itemId: mat.itemId,
              haveNum: defaultNum,
              type: mat.type
            })
          }
        }
      })
    },
    onAuxiliaryChange(itemId, value, index) {
      this.$set(this.auxiliaryNums, index, value)
      const mat = this.selectedRecipe.matList[index]
      const found = this.formulaMatZiList.find(f => f.itemId === itemId)
      if (found) {
        found.haveNum = value
      } else if (value > 0) {
        this.formulaMatZiList.push({
          itemId,
          haveNum: value,
          type: mat.type
        })
      }
    },
    isMaterialEnough(mat, index) {
      return mat.haveNum >= this.getRequiredTotal(mat, index)
    },
    getRequiredTotal(mat, index) {
      if (mat.type === 1) return mat.num
      return Math.max(mat.num, this.auxiliaryNums[index] || 0)
    },
    getRateClass(rate) {
      if (rate >= 0.8) return 'high'
      if (rate >= 0.5) return 'medium'
      return 'low'
    },
    async startRefining() {
      if (!this.canRefine) return
      this.refining = true
      try {
        const res = await this.$http.post('/gameCharaEquip/forgingEquipmentOrPills', {
          charaId: this.getCookie('charaId'),
          packItemIds: this.selectedRecipe.formulaId,
          matList: this.formulaMatZiList,
          type: 2,
          batchCount: this.selectedRecipe.batchMax || 12
        })
        if (res.data.status === 200) {
          this.$Message.success(res.data.data || res.data.msg || '炼丹委托成功')
          this.$emit('refined')
          await this.loadRecipeList()
          await this.loadDelegatingList()
          if (this.selectedRecipe) {
            const latest = this.recipeList.find(r => r.formulaId === this.selectedRecipe.formulaId)
            if (latest) this.selectRecipe(latest)
          }
        } else {
          this.$Message.warning(res.data.msg)
        }
      } catch (err) {
        this.$Message.error((err.data && err.data.msg) || '炼丹失败')
      } finally {
        this.refining = false
      }
    },
    async loadDelegatingList() {
      try {
        const res = await this.$http.post(
          `/gameCharaEquip/queryForgingPlayer?charaId=${this.getCookie('charaId')}&formulaType=2`
        )
        if (res.data.status === 200) {
          this.delegatingList = (res.data.data || []).filter(item => item.receive === 0)
        }
      } catch (err) {
        console.error('加载委托列表失败', err)
      }
    },
    isAlchemyReceivable(item) {
      if (!item || item.receive !== 0) return false
      const end = new Date(item.linTime).getTime()
      return !isNaN(end) && end <= Date.now()
    },
    isAlchemyProcessing(item) {
      if (!item || item.receive !== 0) return false
      return !this.isAlchemyReceivable(item)
    },
    getCountdown(endTime) {
      if (!endTime) return '--'
      const end = new Date(endTime).getTime()
      if (isNaN(end)) return '--'
      const diff = end - Date.now()
      if (diff <= 0) return '00:00'
      const total = Math.floor(diff / 1000)
      const mm = String(Math.floor(total / 60)).padStart(2, '0')
      const ss = String(total % 60).padStart(2, '0')
      return `${mm}:${ss}`
    },
    async receiveAlchemy(item, index) {
      this.receivingIndex = index
      try {
        const res = await this.$http.post(
          `/gameCharaEquip/receiveForgingPlayer?charaId=${encodeURIComponent(this.getCookie('charaId'))}&forPlayerId=${encodeURIComponent(item.id)}`
        )
        if (res.data.status === 200) {
          this.$Message.success('领取成功')
          this.delegatingList.splice(index, 1)
          this.$emit('received')
        } else {
          this.$Message.warning(res.data.msg)
        }
      } catch (err) {
        this.$Message.warning((err.data && err.data.msg) || '领取失败')
      } finally {
        this.receivingIndex = null
      }
    },
    getCookie(name) {
      const value = `; ${document.cookie}`
      const parts = value.split(`; ${name}=`)
      if (parts.length === 2) return parts.pop().split(';').shift()
      return ''
    }
  }
}
</script>

<style scoped>
.alchemy-room {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.room-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);
  border-radius: 12px 12px 0 0;
  color: #fff;
  flex-shrink: 0;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}

.room-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.room-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
}

.desc-icon {
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.2s;
}

.desc-icon:hover {
  opacity: 1;
}

.room-desc {
  margin: 4px 0 0;
  font-size: 13px;
  opacity: 0.9;
}

.design-desc-content {
  font-size: 12px;
  line-height: 1.6;
  color: #515a6e;
}

.design-desc-content .desc-title {
  font-size: 14px;
  font-weight: 600;
  color: #1f2d3d;
  margin-bottom: 6px;
  padding-bottom: 4px;
  border-bottom: 1px solid #e8e8e8;
}

.design-desc-content p {
  margin: 0;
}

.design-desc-content .highlight {
  color: #ff6b6b;
}

.header-stats {
  display: flex;
  gap: 20px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stat-label {
  font-size: 11px;
  opacity: 0.8;
}

.stat-value {
  font-size: 16px;
  font-weight: 600;
}

.room-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.alchemy-tabs {
  display: flex;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  flex-shrink: 0;
}

.alchemy-tab {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  color: #808695;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.2s;
}

.alchemy-tab:hover {
  color: #2d8cf0;
  background: #f0f7ff;
}

.alchemy-tab.active {
  color: #2d8cf0;
  border-bottom-color: #2d8cf0;
}

.tab-count {
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 10px;
  background: #edf4ff;
  color: #2d8cf0;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}

.alchemy-layout {
  flex: 1;
  display: flex;
  overflow: hidden;
}

.recipe-list-panel {
  width: 300px;
  border-right: 1px solid #e8e8e8;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.list-header {
  padding: 12px;
  border-bottom: 1px solid #e8e8e8;
  background: #f8f9fa;
}

.list-title {
  font-size: 15px;
  font-weight: 600;
  color: #1f2d3d;
  margin-bottom: 10px;
}

.list-actions {
  display: flex;
  gap: 8px;
}

.recipe-items {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
}

.recipe-item {
  padding: 12px;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.recipe-item:hover {
  border-color: #2d8cf0;
  background: #f0f7ff;
}

.recipe-item.active {
  border-color: #2d8cf0;
  background: #e6f7ff;
}

.recipe-item.can-make {
  border-left: 3px solid #19be6b;
}

.recipe-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.recipe-name {
  font-size: 14px;
  font-weight: 600;
  color: #1f2d3d;
}

.recipe-status .status-tag {
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 4px;
}

.recipe-status .status-tag.success {
  background: #f6ffed;
  color: #19be6b;
}

.recipe-status .status-tag.disabled {
  background: #fff1f0;
  color: #ed4014;
}

.recipe-info {
  display: flex;
  gap: 12px;
  font-size: 12px;
  color: #808695;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 4px;
}

.recipe-detail-panel {
  flex: 1;
  overflow-y: auto;
  padding: 14px;
  background: #f8f9fa;
}

.detail-header {
  margin-bottom: 12px;
}

.detail-title {
  margin: 0 0 4px;
  font-size: 18px;
  font-weight: 700;
  color: #1f2d3d;
}

.detail-desc {
  font-size: 13px;
  color: #808695;
  line-height: 1.5;
}

.materials-section {
  background: #fff;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 10px;
  border: 1px solid #e8e8e8;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #1f2d3d;
  margin-bottom: 8px;
}

.material-status {
  margin-left: auto;
  font-size: 12px;
  font-weight: 500;
}

.material-status.ready {
  color: #19be6b;
}

.material-status:not(.ready) {
  color: #ed4014;
}

.materials-grid {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.material-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e8e8e8;
}

.material-item.sufficient {
  border-color: #b7eb8f;
  background: #f6ffed;
}

.material-item.insufficient {
  border-color: #ffa39e;
  background: #fff1f0;
}

.material-item.main-material {
  border-width: 2px;
}

.material-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.material-type {
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 4px;
  background: #e6f7ff;
  color: #2d8cf0;
}

.material-name {
  font-size: 14px;
  font-weight: 500;
  color: #1f2d3d;
}
.material-source{display:block;margin-top:2px;color:#7b5d2c;font-size:10px;font-weight:700}

.material-quantity {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
}

.material-quantity .current {
  font-weight: 600;
  color: #1f2d3d;
}

.material-quantity .separator {
  color: #808695;
}

.material-quantity .required {
  color: #808695;
}

.material-input {
  width: 100px;
}

.alchemy-info {
  background: #fff;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 10px;
  border: 1px solid #e8e8e8;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.info-block {
  text-align: center;
}

.block-label {
  font-size: 12px;
  color: #808695;
  margin-bottom: 4px;
}

.block-value {
  font-size: 14px;
}

.rate-number {
  font-size: 22px;
  font-weight: 700;
}

.rate-number.high {
  color: #19be6b;
}

.rate-number.medium {
  color: #ff9900;
}

.rate-number.low {
  color: #ed4014;
}

.rate-detail {
  font-size: 11px;
  color: #808695;
  margin-top: 4px;
}

.proficiency-level {
  font-size: 16px;
  font-weight: 700;
  color: #2d8cf0;
}

.proficiency-text {
  font-size: 11px;
  color: #808695;
  margin-top: 4px;
}

.cost-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-bottom: 4px;
  font-size: 14px;
  color: #1f2d3d;
}

.alchemy-action {
  background: #fff;
  border-radius: 10px;
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid #e8e8e8;
}

.batch-info {
  font-size: 13px;
  color: #808695;
  white-space: nowrap;
  flex-shrink: 0;
}

.refine-btn {
  flex-shrink: 0;
  margin-left: auto;
  padding: 6px 24px;
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);
  border: none;
}

.refine-btn:hover:not(:disabled) {
  box-shadow: 0 4px 12px rgba(255, 107, 107, 0.4);
}

.refine-btn:disabled {
  background: #dcdee2;
  color: #808695;
}

.cannot-refine-reason {
  font-size: 12px;
  color: #ed4014;
  white-space: nowrap;
}

.no-selection {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #808695;
}

.no-selection h3 {
  margin: 20px 0 10px;
  color: #1f2d3d;
  font-size: 20px;
}

.no-selection p {
  font-size: 14px;
}

.delegating-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 1;
}

.section-header h4 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #1f2d3d;
}

.delegating-list {
  flex: 1;
  overflow-y: auto;
  padding: 10px 16px;
  min-height: 0;
}

.delegating-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 6px;
  margin-bottom: 8px;
  border: 1px solid #e8e8e8;
}

.delegating-item.can-receive {
  border-color: #b7eb8f;
  background: #f6ffed;
}

.delegating-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.delegating-name {
  font-size: 14px;
  font-weight: 500;
  color: #1f2d3d;
}

.delegating-status .status-tag {
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 4px;
}

.delegating-status .status-tag.waiting {
  background: #f6ffed;
  color: #19be6b;
}

.delegating-status .status-tag.processing {
  background: #fff7e6;
  color: #fa8c16;
}

.delegating-status .status-tag.completed {
  background: #f0f0f0;
  color: #808695;
}

.delegating-detail {
  font-size: 12px;
  color: #808695;
}

.empty-state {
  text-align: center;
  padding: 20px;
  color: #808695;
}

@media (max-width: 768px) {
  .room-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .header-stats {
    width: 100%;
    justify-content: space-around;
  }

  .alchemy-layout {
    flex-direction: column;
  }

  .recipe-list-panel {
    width: 100%;
    max-height: 300px;
    border-right: none;
    border-bottom: 1px solid #e8e8e8;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cave/AlchemyRoom.vue